/**
 * The pill tone of a campaign's status: running is green, paused amber, a
 * draft and a finished campaign quiet.
 */
import type { CampaignStatus } from "../../../../lib/aiCampaigns";
import type { StatusTone } from "../../../ui";

export function campaignStatusTone(status: CampaignStatus): StatusTone {
  if (status === "active") return "ok";
  if (status === "paused") return "wt";
  return "mut";
}
